import BookCard from "./BookCard";

const BooksGrid = ({
  books,
  likedBooks,
  handleLikeClick,
  openBorrowModal,
  openBookDetails,
  getAvailabilityStyle,
  translations,
}) => (
  <div className="flex flex-wrap mb-4">
    {books.map((book) => {
      const availabilityStyle = getAvailabilityStyle(book.bookAvailability);
      return (
        <BookCard
          key={book.id}
          book={book}
          liked={likedBooks[book.id]}
          onLikeClick={() => handleLikeClick(book.id)}
          onActionClick={() =>openBookDetails(book.id)}
          availabilityStyle={availabilityStyle}
          translations={translations}
        />
      );
    })}
  </div>
);

export default BooksGrid;
